import { zodResolver } from '@hookform/resolvers/zod'
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form'

import {useAppDispatch} from "@App/hooks";
import { CloseIcon } from '@App/static/icons/ArrowIcons'

import { IEditAlertModalData } from '@Redux/slices/modals/interfaces'
import {sendUpdatePriceAlert} from "@Redux/slices/sockets/ProxyServiceConnectionSlice";

import { MarketIcon } from '@UI/crypto_exchange/desktop/components/common/MarketIcon'
import { Button } from '@UI/crypto_exchange/desktop/components/controls/Button'
import { AlertForm } from '@UI/crypto_exchange/desktop/pages/spot/components/PriceAlert/components/AlertForm/AlertForm'
import { FormData, formSchema } from '@UI/crypto_exchange/desktop/pages/spot/components/PriceAlert/types'

import { ModalTypes } from '../modalTypes'
import ModalWrapper from '../ModalWrapper'

import s from './styles.module.scss'

export const EditAlertModal = ({
  isOpen,
  setIsOpen,
  sourceCurrency,
  targetCurrency,
  prevData,
}: ModalTypes & IEditAlertModalData) => {
  const dispatch = useAppDispatch()

  const { setValue, handleSubmit, control, ...methods } = useForm<FormData>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      execution_price: String(prevData.execution_price),
      note: prevData.note || '',
      side: prevData.side,
      market_id: String(prevData.market_id)
    },
    mode: 'all',
  })

  const onSubmit: SubmitHandler<FormData> = (data: FormData) => {
    dispatch(sendUpdatePriceAlert({
      uuid: prevData.uuid,
      side: data.side,
      price: data.execution_price,
      note: data.note || '',
    }))
    setIsOpen()
  }

  return (
    <ModalWrapper isOpen={isOpen} setIsOpen={setIsOpen}>
      <div className={s.container}>
        <div className={s.header}>
          <h3>Edit alert</h3>

          <CloseIcon className={s.closeIcon} onClick={setIsOpen} />
        </div>
        <div className={s.content}>
          <div className={s.contentHeader}>
            <div>
              <MarketIcon
                source_currency={sourceCurrency}
                target_currency={targetCurrency}
                className={s.marketIcon}
              />
            </div>
            <div>
              <span>{sourceCurrency}</span>
              <span>/{targetCurrency}</span>
            </div>
          </div>

          <FormProvider {...methods} setValue={setValue} handleSubmit={handleSubmit} control={control}>
            <AlertForm
              prevData={prevData}
              targetCurrency={targetCurrency}
              sourceCurrency={sourceCurrency}
              onSubmit={onSubmit}
              className={s.form}
            >
              <div className={s.modalControl}>
                <Button size="small" variant="outlined" type="button" onClick={setIsOpen}>
                  Cancel
                </Button>
                <Button size="small" type="submit">
                  Update
                </Button>
              </div>
            </AlertForm>
          </FormProvider>
        </div>
      </div>
    </ModalWrapper>
  )
}
